<template>
  <Modal v-model="model" sticky reset-drag-position :title="sorttitle" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="insert_edit_pop knowledgeCategory_pop"  width="800">
    <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <div id="setting_knowledge_panel" style="overflow-y: scroll; width: 968px; height: 493px;" title class="panel-body panel-body-noborder window-body">
      <div style="height: 100%;background: #eeeeee">
        <table>
          <tr valign="top">
            <td style="width:6%"></td>
            <td style="width:40%">
              <div class="tree_pop_div">
                <div class="ztree" id="sortTreePop"></div>
              </div>
            </td>
            <td style="width:1%"></td>
            <td style="width:50%">
              <div id="action_knowledge" style="height: auto; padding-left: 10px; margin: 10px; width: 400px;" class="tabs-container">
                <template>
                  <Tabs size="small" @on-click="changeOperate">
                    <Tab-pane label="添加类目" >
                      <div class="insert_edit_template" style="96% !important">
                        <div class="input_style insert_edit_left">
                          <div class="font_style_set">上级类目:</div>
                          <div class="insert_edit_input">
                            <Select v-model="selectedSuperId" disabled  placeholder="请点击左侧目录选择类目" clearable>
                              <Option v-for="(option, index) in SuperList"  :value="option.id" :key="index">{{option.replyClassName}}</Option>
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div class="insert_edit_template" style="96% !important">
                        <div class="input_style insert_edit_left">
                          <div class="font_style_set">类目标题:</div>
                          <div class="insert_edit_input">
                            <Input v-model="addsortname" placeholder="请输入标题"/>
                          </div>
                        </div>
                      </div>
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="insert_edit_input" style="text-align: center;">
                            <Button type="primary" class="submit_btn"  @click="addnewsort()" v-if="roleList['3_12-4-1']">添加</Button>
                          </div>
                        </div>
                      </div>
                    </Tab-pane>
                    <Tab-pane label="编辑类目" >
                      <div class="insert_edit_template" style="96% !important">
                        <div class="input_style insert_edit_left">
                          <div class="font_style_set">当前类目:</div>
                          <div class="insert_edit_input">
                            <Select v-model="selectedSuperId" disabled placeholder="请点击左侧目录选择类目" clearable>
                              <Option v-for="(option, index) in SuperList" :value="option.id" :key="index">{{option.replyClassName}}</Option>
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div class="insert_edit_template" style="96% !important">
                        <div class="input_style insert_edit_left">
                          <div class="font_style_set">修改类目:</div>
                          <div class="insert_edit_input">
                            <Input v-model="editsortname" placeholder="请输入标题"/>
                          </div>
                        </div>
                      </div>
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="insert_edit_input" style="text-align: center;">
                            <Button type="primary" class="submit_btn" @click="editnewsort()"  v-if="roleList['3_12-4-2']">修改</Button>
                          </div>
                        </div>
                      </div>
                    </Tab-pane>
                    <Tab-pane label="删除类目" >
                      <div class="insert_edit_template" style="96% !important">
                        <div class="input_style insert_edit_left">
                          <div class="font_style_set">当前类目:</div>
                          <div class="insert_edit_input">
                            <Select v-model="selectedSuperId" disabled placeholder="请点击左侧目录选择类目" clearable>
                              <Option v-for="(option, index) in SuperList" :value="option.id" :key="index">{{option.replyClassName}}</Option>
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div class="insert_edit_template">
                        <div class="input_style insert_edit_left">
                          <div class="insert_edit_input" style="text-align: center;">
                            <Button type="primary" class="delete_btn" @click="deletnewsort()"  v-if="roleList['3_12-4-3']">删除</Button>
                          </div>
                        </div>
                      </div>
                    </Tab-pane>
                  </Tabs>
                </template>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "shortcutCategoryPop",
    mixins:[publicFunClass],
    props: {
      showLibraryEdit:Boolean,
      sorttitle:String,
      selectlib:String,//库类型:个人库/公共库
    },
    data(){
      return {
        journalType:'',
        menuId:'',
        model:false,
        spinShow:false,
        roleList:JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        agentInfo: JSON.parse(localStorage.getItem("agentInfo")),

        SuperList:[],
        editsortname:'',
        addsortname:'',

          selectedSuperId :'',//selectedTreeId
          selectedTreePid:'',
          inspectTreeData:[],
        editangent:'',

      }
    },
    methods:{
      cancel:function(){
        this.$emit("closeLibraryEdit",true);
      },
      changeOperate:function () {
        this.editsortname="";
        this.addsortname="";
      },
      initSortmenuTree:function () {//树初始化
              let that=this;
              let setting = {
                view: {
                  dblClickExpand: false,
                  showLine: true,
                  selectedMulti: false
                },
                data: {
                  simpleData: {
                    enable:true,
                    idKey: "id",
                    pIdKey: "pid",
                    rootPId: ""
                  },
                  key:{
                    name:"replyClassName"
                  }
                },
                callback: {
                  onClick: zTreeOnClick,//单击事件
                }
              };

              function zTreeOnClick(event,treeId,treeNode) {
                that.selectedSuperId=treeNode.id;
                that.selectedTreePid=treeNode.pid;
                that.editangent=treeNode.agentNumber;
              }

              let zNodes =this.inspectTreeData;

              if (zNodes){
                $(document).ready(function(){
                  let zTree=$.fn.zTree.init($("#sortTreePop"), setting, zNodes);//t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
                  zTree.expandAll(true);
                  let nodes = zTree.getNodes();
                  if (nodes.length > 0) {
                    zTree.selectNode(nodes[0]);//默认选中根节点
                  }
                });
              }
      },

      initsearchlibrary:function () {//查询左侧树(开始一进来为个人类)
              let param={
                replyType:this.selectlib,
                agentNumber:this.agentInfo.agentNumber,
                meanType:'1'
              };
              let that=this;
              this.$http.post("chatReply/toSelectChatReplyDetail.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Modal.info({
                    title:'提示',
                    content:res.data.msg
                  });
                  return false;
                }
                let list=res.data.obj.list;
                let agentNumber = that.agentInfo.agentNumber;
                if('0' == that.replyType){
                  agentNumber = '';
                }
                let paramTwo={
                  agentNumber:agentNumber,
                  id:'0',
                  pid:'null',
                  replyClassName:'根目录',
                  replyType:that.replyType
                };
                list.push(paramTwo);
                that.inspectTreeData =list;
                that.SuperList=list;
                for (let i=0;i<list.length;i++){
                  let pid=list[i].pid;
                  // if(pid=="0"){
                  //   that.selectedSuperId=list[i].id;
                  // }
                }
                that.initSortmenuTree();
              });
      },


      addnewsort:function(){ //添加
            if(!this.selectedSuperId){
              this.$Modal.info({
                title:'提示',
                content:"上级类目不能为空"
              });
              return false;
            }
            if(!this.addsortname){
              this.$Modal.info({
                title:'提示',
                content:"类目标题不能为空"
              });
              return false;
            }
            let param={
              agentNumber:this.agentInfo.agentNumber,
              id:'',
              pid:this.selectedSuperId,
              replyClassName:this.addsortname,
              replyType:this.selectlib,
              meanType:'1',
              journalType:"系统管理=>会话配置=>快捷回复=>添加类目",
              menuId:"3_12-4-1"
            };
            let that=this;
            this.$http.post("chatReply/doReplySave.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.info("保存成功");
              //that.refreshNode();
              that.initsearchlibrary();
            });
      },
      refreshNode:function() {
        let zTree = $.fn.zTree.getZTreeObj("sortTreePop"),
        type = "refresh",
        silent = false,
        nodes = zTree.getSelectedNodes();
        zTree.reAsyncChildNodes(nodes[0], type, silent);
      },
      editnewsort:function(){ //修改
            if(!this.editsortname){
                this.$Modal.info({
                  title:'提示',
                  content:"分类名称不能为空"
                });
                return false;
            }
            if("0"==this.selectedSuperId || !this.selectedSuperId){
              this.$Modal.info({
                title:'提示',
                content:"根目录不能修改"
              });
              return false;
            }
            let param={
              agentNumber:this.editangent,
              id:this.selectedSuperId,
              pid:this.selectedTreePid,
              replyClassName:this.editsortname,
              replyType:this.selectlib,
              meanType:'1',
              journalType:"系统管理=>会话配置=>快捷回复=>编辑类目",
              menuId:"3_12-4-2"
            };
            let that=this;
            this.$http.post("chatReply/doReplySave.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Message.info("修改成功");
              that.initsearchlibrary();
            });
      },
      deletnewsort:function(){ //删除
        if("0"==this.selectedSuperId || !this.selectedSuperId){
          this.$Modal.info({
            title:'提示',
            content:"根目录不能删除"
          });
          return false;
        }
        let param={
                id:this.selectedSuperId,
                replyType:this.selectlib,
                meanType:'1',
                journalType:"系统管理=>会话配置=>快捷回复=>删除类目",
                menuId:"3_12-4-3"
        };
        let that=this;
          this.$Modal.confirm({
              title: '提示',
              content:'删除会将其下级所有分类及内容删除,是否确定',
              onOk:()=>{
                that.$http.post('chatReply/doDeleteReply.json',param).then(res=>{
                      let response = res.data
                      if (response.flag !== '666') {
                        that.$alert(response.msg,'提示',{
                          confirmButtonText:'确定'
                        })
                        return false
                      }
                      that.$Message.info('删除成功');
                      that.initsearchlibrary();
                })
              }
          })

      },

    },
    created(){
       // this.initsearchlibrary();
      // this.searchBaseName();
    },
    watch:{
      showLibraryEdit:function () {
        this.model=this.showLibraryEdit;

        this.selectedSuperId="";

        this.editsortname="";
        this.addsortname="";
        if(this.showLibraryEdit){
          this.initsearchlibrary();
          // this.searchBaseName();
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/shortcutCategoryPop.vue